export const MAIN = 'main'
export const PROCEDURE_GAME = 'procedureGame'
export const TASK = 'task'
export const INTERACTIVE_SHOP = 'interactiveShop'
export const CUSTOMIZATION = 'customization'
export const GAMES = 'games'
export const RATING = 'rating'
export const GAME_RATING = 'gameRating'
export const CHALLENGES = 'challenges'
export const RULES = 'rules'
export const START = 'start'
export const INFO = 'info'
export const PRELOADER = 'preloader'
export const CREATING = 'creating'
export const OLD_RATING = 'oldRating'
export const GUESS_PRISE = 'guessPrice'
export const FRIENDS = 'friends'
export const WISH = 'wish'
export const YEAR_STAT = 'yearStat'
export const SHOP = 'shop'
export const SHELF = 'shelf'
export const SETS = 'sets'
export const ROADMAP = 'roadmap'
export const RAFFLE = 'raffle'
export const MATCH_3 = 'match3'
export const JUMPER = 'jumper'
export const PLATFORM = 'platform'
export const MEMORIES = 'memories'
